import ReactStrapTable from 'components/reactStrapTable';
import React, { useEffect, useState } from 'react'
import EditIcon from 'assets/icon/icon-icon-options-edit.svg';
import ConfigIcon from "assets/icon/config-setting-icon.svg";
import ConfigIconHover from "assets/icon/config-setting-icon-hover.svg";
import EditHoverIcon from 'assets/icon/icon-icon-options-edit_hover.svg';
import HoverImage from 'react-hover-image/build';
import { Button, Col, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import { dateFormate, currencyFormat, cellRendererCheck } from 'utils/columns';
import Drawer from 'components/Drawer';
// import SearchOrderDrawer from '../SearchOrder/SearchOrderDrawer';
import EyeIcon from 'assets/icon/icon-icon-options-view-patient.svg';
import EyeIconHover from 'assets/icon/icon-icon-options-view-patient_hover.svg';
// import ViewPurchaseOrder from '../SearchOrder/ViewSearchOrder';
import Download from 'assets/icon/download.svg';
import DownlaodHower from 'assets/icon/download_hover.svg';
import Delete from 'assets/icon/icon-icon-options-delete.svg';
import DeleteHower from 'assets/icon/icon-icon-options-delete-hover.svg';
import Order from "assets/icon/icon-icon-options-order-complete.svg"
import OrderHower from "assets/icon/icon-icon-options-order-complete-hover.svg"
import  NotEligible from "assets/icon/icon-icon-options-not-eligible.svg"
// import Attachments from '../PurchaseOrderAttachments';
import { Formik } from 'formik';
import Attachments from '../ViewAttachments';
import ViewAuditItems from '../ViewAuditItems';
import AuditProgramNotes from 'components/AuditProgramNotes';
import { ModuleAccess } from 'utils/moduleaccess';
import cancel from "assets/icon/cancel.svg";
import DeleteIcon from "assets/icon/Delete.svg"



const ViewAuditToolTable = (props) => {
    const {
      tableData,
      orgId,
        manvalConfig,
        manvalPharmacy,
        collapseSider,
        toggleSider,
        viewauditflag,
        setViewAuditflag,
        selectedviewAudit,
        setSelectedViewAudit,
        
      
        
    } = props;
    
//    const [tableData, setTableData] = useState([]);
    const [isPODetailsOpen, setisPODetailsOpen] = useState(false);
    const [drawerPODetails, setDrawerPODetails] = useState('');
    const [isOpenView, setOpenView] = useState(false);
    const [isOpenHistory, setOpenHistory] = useState(false);
    const [selectedRowHistory, setSelectedRowHistory] = useState({});
    const [commentDrawer, setCommentDrawer] = useState(false);
    
    const [modal, setModal] = useState(false);
    const [AuditItem , setAuditItem] = useState(false);
  const [selectedRow, setselectedRow] = useState({});

    const toggle = () => setModal(!modal);
   
    const [viewAudit , setViewAduit] = useState(false);
  

    const toggleViewAudit = () => {
        setViewAduit(!viewAudit);
      };

  
      const hasPermission = (code) => {
        return ModuleAccess("ADT", code);
    }
    const togglePODetailsDrawer = () => {
        setisPODetailsOpen(!isPODetailsOpen);
        setDrawerPODetails('');
      };
      
    const toggleViewPODetailsDrawer = () => {
        setOpenView(!isOpenView);
        // setDrawerPODetails('');
      };
      const toggleAttachPODetailsDrawer = () => {
        setCommentDrawer(!commentDrawer);
        // setDrawerPODetails('');
      };
    const handelViewAudit = async (rowData) => {
        //  await toggleViewAudit();

    }
    const handelAddCoveredEntity = async (rowData) => {
        await manvalPharmacy();

   }
    
    // const renderWacPrice = () => {
    //     // if (hasPermission('EDT'))
    //         return <Button
    //             className='text-primary p-0 text-decoration-none'
    //             color='link'
    //             onClick={() => handelWacPrice()}
    //             title='Edit Covered Entity'

    //         >
    //             <HoverImage src={EditIcon}
    //                 hoverSrc={EditHoverIcon}
    //                 alt='' />
    //         </Button>
    // }

    const renderConfigButton = () => {

        return <Button
            className='text-primary p-0 text-decoration-none'
            color='link'
            onClick={() => handleConfig()}
            title='Client Configuration'

        >
            <HoverImage
                src={ConfigIcon}
                hoverSrc={ConfigIconHover}
                alt='' />
        </Button>
    }

    const renderViewButton = (rowData) => {
        return (
            <Button
                className='text-primary p-0 text-decoration-none'
                color='link'
                onClick={()=> manvalitem(rowData)}
                title=' Audit Items'
            >
                <HoverImage
                    key='EyeIcon'
                    src={EyeIcon}
                    hoverSrc={EyeIconHover}
                    alt=''
                />
            </Button>
        );
    };
    const toggleView = (rowData) => {
        setOpenView(!isOpenView);
        setselectedRow(rowData);
    };
    // const renderAttachementsButton = (rowData) => {
    //     // if (hasPermission('AT'))
    //         return (
    //         <Button
    //             className='text-primary p-0 text-decoration-none'
    //             color='link'
    //             onClick={() => toggleViewAudit(rowData)}
    //             title="Attachments"
    //         >
    //             <HoverImage
    //                 key='Attachments'
    //                 src={Download}
    //                 hoverSrc={DownlaodHower}
    //                 alt=''
    //             />
    //         </Button>
    //         )
    // }
    const renderDownloadButton = (rowData) => {
       if (hasPermission('DT'))
          return (
          <Button
              className='text-primary p-0 text-decoration-none'
              color='link'
              onClick={() => toggleViewAudit(rowData)}
              title="Delete Audit"
          >
              <HoverImage
                  key='Delete Audit'
                  src={Download}
                  hoverSrc={DownlaodHower}
                  alt=''
              />
          </Button>
          )
  }
    const renderDeleteButton = (rowData) => {
        if (hasPermission('DT'))
            return (
            <Button
                className='text-primary p-0 text-decoration-none'
                color='link'
                onClick={() => toggle(rowData)}
                title='Download'
            >
                <HoverImage
                    key='Download'
                    src={Delete}
                    hoverSrc={DeleteHower}
                    alt=''
                />
            </Button>
            )
    }
    const manvalitem = (rowdata) => {
      debugger;
    setAuditItem(!AuditItem);
   setselectedRow(rowdata);
   setViewAuditflag(true)
   setSelectedViewAudit(rowdata)
      };
    const renderNotEligibleButton = (rowData) => {
        // if (hasPermission('AT'))
            return (
            <Button
                className='text-primary p-0 text-decoration-none'
                color='link'
                onClick={() => toggle(rowData)}
                title='Elgible Claim'
            >
                <HoverImage
                    key='Elgible Claim'
                    src={Order}
                    hoverSrc={OrderHower}
                    alt=''
                />
            </Button>
            )
    }
    const toggleCommentDrawer = (rowData) => {
        setCommentDrawer((pre) => !pre);
        setCommentRowData(rowData);
    };

    const cellRenderEdit = (rowData) => {
        return (
            <div className='d-flex align-items-center'>
                {/* {renderWacPrice()} */}
               
                {renderViewButton(rowData)}
               
                {renderDownloadButton(rowData)}
                {renderDeleteButton(rowData)}
            </div>
        );
    };
   
    
    const handleExport = async () => {
        const { access_token } =
            JSON.parse(localStorage.getItem('pharmaforce')) || {};
        const action = `${process.env.REACT_APP_ENDPOINT}/${process.env.REACT_APP_ENDPOINT_POSTFIX}/${tenantID}/Reports/ExportManufacturerAlls?access_token=${access_token}`;
        // onExport(action, initialFilters);
    };
    let mainCol = [
        {
            dataField: 'edit',
            text: 'Options',
            cellRenderer: (rowData) => cellRenderEdit(rowData),
            width: 120,
            show: true,
            disabled: true,
            hideColFilter: true,
            action: true,
        },

        {
            dataField: 'chargeAuditID',
            text: 'Audit ID',
            sort: false,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.chargeAuditID),
        },
        {
            dataField: 'auditName',
            text: 'Audit Name',
            sort: false,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.auditName),
        },
        {
            dataField: 'dateRange',
            text: 'Date Range',
            sort: false,
            width: 200,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.dateRange),
        },
        {
            dataField: 'generatedDate',
            text: 'Generated Date',
            sort: false,
            width: 160,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => dateFormate(row.generatedDate),
        },
        {
            dataField: 'recordCount',
            text: 'Record Count',
            sort: false,
            width: 120,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.recordCount),
        },
        {
            dataField: 'eligibleClaimCount',
            text: 'Charges Passed',
            sort: false,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.eligibleClaimCount),
        },
        {
            dataField: 'inEligibleClaimCount',
            text: 'Charges Failed',
            sort: false,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.inEligibleClaimCount),
        
        },
        {
            dataField: 'successRate',
            text: 'Pass Rate',
            sort: false,
            width: 100,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.successRate),
        },
        {
            dataField: 'accumulatorName',
            text: 'Accumulator',
            sort: false,
            width: 200,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.accumulatorName),
        },
        {
            dataField: 'modifiedByID',
            text: 'User Name',
            sort: false,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.modifiedByID),
        },
        
       

    ];
    const cellRenderLink = (rowData) => {
        // if (hasPermission('VWPO')) {
          return (
            <span
              className='text-decoration-underline d-inline-block cursor-pointer'
              onClick={() => handelWacPrice(rowData)}
            >
              {rowData}
            </span>
          );
        // }
      };
      const cellRender340BLink = (rowData) => {
        // if (hasPermission('VWPO')) {
          return (
            <span
              className='text-decoration-underline d-inline-block cursor-pointer'
              onClick={() => handel340BPrie(rowData)}
            >
              {rowData}
            </span>
          );
        // }
      };
      const cellRenderGpoPriceLink = (rowData) => {
        // if (hasPermission('VWPO')) {
          return (
            <span
              className='text-decoration-underline d-inline-block cursor-pointer'
              onClick={() => handelGpoPrice(rowData)}
            >
              {rowData}
            </span>
          );
        // }
      };
    const handlePODetails = (row) => {
        setisPODetailsOpen(!isPODetailsOpen);
        setDrawerPODetails('OrderDetails');
        // setPORowData(row);
      };
    
  return (
    
    <div>
     <div>
       <h5 className="f-16 text-primary font-weight-700">
            Audit History Count ({tableData?.length})
            </h5>
            <hr/>
              <div
            // className='table-card scroll-table position-relative border-0 rounded pt-0'
            // fixed-height={tableData?.length > 0 ? 'fixed-height' : 'default'}
            className="table-card scroll-table position-relative border-0 rounded pt-0"
        fixed-height={
          tableData.length > 0
            ? `${collapseSider ? "collapse-fixed-height" : "fixed-height"}`
            : "default"
        }
        >
            <ReactStrapTable
                id='audit-table'
                height={550}
                fixedColumn
                width={1200}
                // reset={reset}
                data={tableData}
                columns={mainCol}
                collapseSider={collapseSider}
                toggleSider={toggleSider}
                showtoggle={true}
                // add={"Upload"}
                // addbutton={true}
                // buttononclick={toggle}
                
                // handelAddCoveredEntity={handelAddCoveredEntity}
                  onExport={handleExport}
                // filters={2}
                 totalRecords={1}
                 pageSize={20}
                 currentPage={1}
                // handleSort={onHandleSort}
                // onPageChange={onHandlePageChange}
                // onPageSizeChange={onPageSizeChange}
                // onFilterCancel={handleFilterCancel}
                // onSearchColumnFilters={handleSearchColumnFilters}
                // hasExportPermission={hasExportPermission}
            />
        </div>
        </div>
     
        
      <Modal isOpen={modal} fade={false} toggle={toggle} className={props.className}>
        <ModalHeader toggle={toggle}><h5 className="f-15 text-primary font-weight-700 mt-2">
        Delete Aduit
    </h5></ModalHeader>
        <ModalBody>
<div>
<div>
    <h6>Do You wish to delete this Audit </h6>
</div>
      </div>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" className='search' onClick={toggle}>  <span className="right_5">
                                        <img src={DeleteIcon} alt="" />
                                      </span> Delete</Button>{' '}
          <Button color="primary" className='reset' onClick={toggle}>                            
            <span className="right_5">
                                        <img src={cancel} alt="" />
                                      </span>
                                       Cancel</Button>{' '}

        </ModalFooter>
      </Modal>
    
      <Drawer
        direction="end"
        title=" Audit Items"
        isOpen={viewAudit}
        toggle={toggleViewAudit}
        size="lg"
      >
        <Attachments  />
      </Drawer>
     
      {/* <Drawer
        direction="end"
        title="Audit Details"
        isOpen={AuditItem}
        toggle={manvalitem}
        size="lg"
      >
        <ViewAuditItems selectedRow={selectedRow} orgId={orgId}/>
      </Drawer> */}
    </div>
  )
}

export default ViewAuditToolTable
